import { type SectionType, type TermType } from "components/server-types";
import { isLinkedSection, isTemplateSection } from "utils/publishing";

/**
 * A section is considered archived if it, its term, or (for linked sections) its template section
 * is archived. Shared by the `useIsArchived` hook and the `selectCurrentSectionIsArchived` selector.
 *
 * @param terms term entities keyed by id (e.g. from `termSelectors.selectEntities`).
 * @param sections sections to search for the linked section's template (template sections, or all
 *   sections — ids are unique so either works).
 */
export const isSectionArchived = (
  section: SectionType | null | undefined,
  terms: Record<string, TermType | undefined>,
  sections: SectionType[],
): boolean => {
  if (!section) return false;
  const term = section.term_id ? terms[section.term_id] : undefined;
  const templateSection = isLinkedSection(section)
    ? sections.find((s) => isTemplateSection(s) && s.id === section.template_id)
    : undefined;

  return Boolean(section.archived_at || term?.archived_at || templateSection?.archived_at);
};
